import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AppCommonModule } from '@common/app-common.module'
import { ElectronicProcessPaginationChangesComponent } from './electronic-process-pagination-changes.component'
import { ElectronicProcessPaginationFailuresComponent } from './electronic-process-pagination-failures.component'
import { ElectronicProcessPaginationHistoryComponent } from './electronic-process-pagination-history.component'
import { ElectronicProcessPaginationSimulationComponent } from './electronic-process-pagination-simulation.component'

/** Paginação do processo eletrônico (spec 002): histórico, simulação de renumeração e lista de falhas. */
@NgModule({
	declarations: [
		ElectronicProcessPaginationChangesComponent,
		ElectronicProcessPaginationFailuresComponent,
		ElectronicProcessPaginationHistoryComponent,
		ElectronicProcessPaginationSimulationComponent
	],
	imports: [CommonModule, AppCommonModule],
	exports: [
		ElectronicProcessPaginationChangesComponent,
		ElectronicProcessPaginationFailuresComponent,
		ElectronicProcessPaginationHistoryComponent,
		ElectronicProcessPaginationSimulationComponent
	]
})
export class ElectronicProcessPaginationModule {}
